import { render, staticRenderFns } from "./SurveyPage.vue?vue&type=template&id=d5ce6b0c&lang=pug"
import script from "./SurveyPage.vue?vue&type=script&lang=js"
export * from "./SurveyPage.vue?vue&type=script&lang=js"
import style0 from "./SurveyPage.vue?vue&type=style&index=0&id=d5ce6b0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports